import { guacHttpClient } from "@/lib/http";
import { useMutation } from "@tanstack/react-query";

export function useTextAIOutreachHandoff() {
  const mutation = useMutation({
    mutationFn: async (id: string) => {
      const path = `text-ai-outreaches/${id}/handoff`;
      await guacHttpClient.post(path);
    },
  });

  return mutation;
}
